import update from 'immutability-helper';

import {
    LOAD_BANCOS,
    CREATE_BANCO,
    UPDATE_BANCO,
    DELETE_BANCO,
} from './actions';

export var defaultState = {
    data: [],
    isLoading: false,
    drawer: {
        visible: false,
        record: null,
    },
};

var ACTION_HANDLERS = {
    [LOAD_BANCOS.INIT]: function(state, action) {
        return update(state, {
            isLoading: { $set: true },
        });
    },

    [LOAD_BANCOS.SUCCESS]: function(state, action) {
        return update(state, {
            isLoading: { $set: false },
            data: { $set: action.payload.data.data },
        });
    },

    [LOAD_BANCOS.FAIL]: function(state, action) {
        return update(state, {
            isLoading: { $set: false },
        });
    },

    [CREATE_BANCO.SUCCESS]: function(state, action) {
        return update(state, {
            data: { $unshift: [action.payload.data.data] },
        });
    },

    [UPDATE_BANCO.SUCCESS]: function(state, action) {
        var updatedRecord = action.payload.data.data;
        return update(state, {
            data: {
                $set: state.data.map(function(item) {
                    if (item.id === updatedRecord.id) {
                        return updatedRecord;
                    }
                    return item;
                }),
            },
        });
    },

    [DELETE_BANCO.SUCCESS]: function(state, action) {
        var deletedId = action.meta.previousAction.id;
        return update(state, {
            data: {
                $set: state.data.filter(function(item) {
                    return item.id !== deletedId;
                }),
            },
        });
    },
};

var reducer = function(state, action) {
    if (state === undefined) state = defaultState;

    var handler = ACTION_HANDLERS[action.type];
    if (!handler) return state;

    return handler(state, action);
};

export default reducer;
